import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useLocation } from 'react-router-dom';

import { FormReferent } from './form/';
import { Password } from './password';
import { LinkReferent } from './link';

import ReferentIlustration from './../../assets/images/placeholder/YoungReferent-ilustration.svg';

export const Referent = () => {
    const location = useLocation();

    return (
        <main role="main" className="flex-grow-1 pb-sm pb-xl-gutter" style={{ minHeight: "600px" }} >
            <div className="container-fluid container-modal m-auto h-inherit">
                <section className="card card-body card-lg rounded-top-left-xl rounded-bottom-right-xl" style={{ minHeight: "600px" }}>
                    <h4 className="sr-only visually-hidden">Registration de Compte</h4>
                    <div className="row justify-content-row gx-2 h-inherit">
                        <div className="col-12 col-lg-auto col-xl-5 h-inherit">
                            <img className="img-max img-contain mw-100 container-md-wide mx-auto mt-4 mb-lg-auto" width="300" src={ReferentIlustration} alt="Assist@" />
                        </div>
                        <div className="col order-first order-lg-last h-inherit ">
                            <nav className="nav text-right mb-auto">
                                <h1 className="sr-only visually-hidden">Register</h1>
                                {/* <span className="small font-weight-bold ml-auto">Je n'ai pas de compte ? <Link className="text-primary" to="/auth/signup">S'inscrire</Link></span> */}
                            </nav>
                            <Switch>
                                <Route exact path="/auth/referent" component={FormReferent} />
                                <Route exact path="/auth/referent/password" component={Password} />
                                <Route exact path="/auth/referent/link" component={LinkReferent} />

                                <Route render={() => {
                                    return <Redirect to={`/auth/referent${location.search}`} />;
                                }} />
                            </Switch>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    );
};